import {
  KnownHistoricDeliveryStatsAggregationPeriod,
  KnownHistoricDeliveryStatsEventTypes
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { Grid, MenuItem, TextField, useMediaQuery, useTheme } from '@mui/material';
import { ToggleButton } from '../../../../../ui/components/pure/toggle-button/toggle-button.component';
import { useDashboardStatsContext } from '../../../context/use-dashboard-stats.context';
import { historicOrderStatsEventTypeToLabel } from '../../../dashboard.constants';
import { HistoricOrderStatsEventTypeOptions } from '../../../hooks/useHistoricStats';
import { DashboardCardTitle } from '../../dashboard-card-title/dashboard-card-title.component';

export function EventHistoryHeader() {
  const { historicStats } = useDashboardStatsContext();

  const theme = useTheme();
  const isXS = useMediaQuery(theme.breakpoints.down('sm'));

  const EventTypeInput = () => (
    <TextField
      variant="outlined"
      select
      size="small"
      value={historicStats.state.eventType}
      onChange={(event) =>
        historicStats.handlers.onChangeEventType(event.target.value as HistoricOrderStatsEventTypeOptions)
      }
    >
      {eventTypeOptions.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );

  const AggPeriodButtons = () => (
    <>
      {availableAggPeriods.map((period) => (
        <Grid key={period} style={{ width: isXS ? '100%' : 'auto' }}>
          <ToggleButton
            fullWidthOnMobile
            color="secondary"
            label={`By ${period}`}
            isSelected={period === historicStats.state.aggPeriod}
            onClick={() => historicStats.handlers.onChangeAggPeriod(period)}
          />
        </Grid>
      ))}
    </>
  );

  return isXS ? (
    <Grid container sx={{ flexDirection: 'column' }} spacing={1} style={{ marginBottom: '8px' }}>
      <Grid
        container
        sx={{
          justifyContent: 'space-between'
        }}
      >
        <Grid>
          <DashboardCardTitle title="History" />
        </Grid>
        <Grid>
          <EventTypeInput />
        </Grid>
      </Grid>
      <Grid
        container
        wrap="nowrap"
        spacing={1}
        sx={{
          justifyContent: 'space-between'
        }}
      >
        <AggPeriodButtons />
      </Grid>
    </Grid>
  ) : (
    <Grid
      container
      wrap={isXS ? 'wrap' : 'nowrap'}
      style={{ marginBottom: '8px' }}
      sx={{
        justifyContent: 'space-between'
      }}
    >
      <Grid>
        <DashboardCardTitle title="History" />
      </Grid>
      <Grid
        container
        spacing={1}
        sx={{
          justifyContent: 'flex-end'
        }}
      >
        <Grid>
          <EventTypeInput />
        </Grid>
        <Grid container wrap="nowrap" style={{ width: isXS ? '100%' : 'auto' }} spacing={1}>
          <AggPeriodButtons />
        </Grid>
      </Grid>
    </Grid>
  );
}

const availableAggPeriods = [
  KnownHistoricDeliveryStatsAggregationPeriod.Day,
  KnownHistoricDeliveryStatsAggregationPeriod.Week,
  KnownHistoricDeliveryStatsAggregationPeriod.Month
];

const availableEventTypes = [
  KnownHistoricDeliveryStatsEventTypes.Bookings,
  KnownHistoricDeliveryStatsEventTypes.Deliveries,
  KnownHistoricDeliveryStatsEventTypes.Collections,
  KnownHistoricDeliveryStatsEventTypes.Retrievals,
  KnownHistoricDeliveryStatsEventTypes.Cancellations
];

const eventTypeOptions = availableEventTypes.map((type) => ({
  value: type,
  label: historicOrderStatsEventTypeToLabel[type]
}));
